const RedStar = () => {
  return <span class="text-danger">*</span>;
};

export default RedStar;
